import { useContext } from "react";
import { AppContext } from "../../Context";
import { Preloader } from "../Preloader";

export const TarefasAConcluir = () => {   
    const {
        dto, 
        dtoLength,
    } = useContext(AppContext);

    return !dtoLength ? (
        <p>{dtoLength === null ? <Preloader></Preloader> : "Não há tarefa pendente"}</p>
      ) : (
        <table className="highlight">
            <thead>
                <tr>
                    <th>Tarefa</th>
                    <th>&nbsp;&nbsp;&nbsp;&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                {dto.map(({idtarefa,nome,pconcluido})=>{
                    return(
                    <tr key={idtarefa}>
                        <td>{nome}</td>
                        <td>{pconcluido}%</td>
                    </tr>)
                })}
            </tbody>
        </table>
    );
};


export const TarefasConcluidas = () => {   
    const {dto, dtoLength} = useContext(AppContext);

    return !dtoLength ? (
        <p>{dtoLength === null ? <Preloader></Preloader> : "Nenhuma tarefa concluída!"}</p>
      ) : (
        <table className="highlight">
            <thead>
                <tr>
                    <th>Tarefa</th>
                </tr>
            </thead>
            <tbody>
                {dto.map(({idtarefa,nome})=>{
                    return(
                    <tr key={idtarefa}>
                        <td>{nome}</td>
                    </tr>)
                })}
            </tbody>
        </table>
    );
}
